import React from "react";

const RewardContent = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white section_space z-2 pt-0 pb-0 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          {/* <div className="col-lg-6"> */}
          <div className="col-lg-12">
            {/* <div className="border-end px-4"> */}
            <div>
              <div className="mt-4">
                <h1 className=" text-theme">
                  Understand How Your TopCoin UK Rewards Work
                </h1>
                <p className="text-dark opacity-50">
{/*                   TopCoin UK is a loyalty and rewards programme. As you engage
                  with participating businesses, you collect free TopCoin and
                  may unlock additional company-funded cash rewards based on
                  predefined milestones. */}
                  TopCoin UK operates as a loyalty and advertising rewards platform.
                </p>
                <p className="text-dark opacity-50">
                  {/* TopCoin is not money, not a financial product, and not an
                  investment. Cash rewards are discretionary loyalty benefits
                  provided by the company and are not guaranteed. */}
                  When you shop with participating businesses, you may receive free 
                  TopCoin loyalty issued by those businesses as part of their promotional activity.
                </p>
                <p className="text-dark opacity-50">
{/*                   At every level, As you engage with the TopCoin UK loyalty
                  programme, you unlock additional TopCoin rewards and
                  discretionary cash rewards provided by the company. */}
                  TopCoin is not money, not a financial product, and not an investment.
                </p>
                <p className="text-dark opacity-50">
            {/*       To understand your reward progress, you can view the total
                  TopCoin you have collected and any associated rewards that
                  have been released, simply add the total value from each level
                  you’ve reached, including your TopCoin balance and any company
                  cash rewards that have been unlocked through loyalty
                  milestones. */}
                  It is a loyalty unit used to track customer participation and 
                  merchant-funded discounts within the TopCoin UK programme.
                </p>
                <p className="text-dark opacity-50">
{/*                   Our goal is to help you reach the highest level, where Our aim
                  is to reward long-term customer loyalty through a structured
                  rewards programme. Rewards are not guaranteed and are not
                  financial products. Because here, loyalty is recognised and
                  rewarded. */}
                </p>
                <h5 className="fw-medium text-dark-emphasis fw-bold mt-2">
                 {/*  Understanding the Cash Wallets System */}
                 How TopCoin Rewards Are Tracked
                </h5>
                
                <p className="text-dark opacity-50">
                As you engage with participating retailers, your TopCoin balance
                increases based on merchant-issued promotions
                </p>

                <p className="text-dark opacity-50">
                These loyalty topcoin help record your activity within the programme and may 
                unlock additional discretionary rewards according to predefined programme milestones.
                </p>
                {/* //changed */}

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                    TopCoins:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                      Are issued free of charge by participating businesses
                      </li>
                      <li>
                        Do not increase in value
                      </li>
                      <li>
                        Do not earn interest
                      </li>
                      <li>
                        Are not guaranteed to result in cash rewards
                      </li>
                    </ul>
                    </div>
                </div> 

                <h5 className="fw-medium text-dark-emphasis fw-bold mt-4">
                  Understanding Reward Progress
                </h5>

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      Your wallet displays
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                        The total number of TopCoins collected
                      </li>
                      <li>
                        Any discretionary loyalty rewards that have been unlocked under programme rules
                      </li>
                    </ul>
                  </div>
                </div>

                <p className="text-dark opacity-50">
                  All figures shown are for illustrative and tracking purposes only and reflect participation
                  in the loyalty programme rather than entitlement to money.
                </p>

                <h5 className="fw-medium text-dark-emphasis fw-bold mt-2">
                  Understanding the Reward Cash Wallets
                </h5>

                
                <p className="text-dark opacity-75 mb-0">
                 {/*  (Company-funded loyalty rewards, separate from TopCoin
                  balances) */}
                  (Company-funded loyalty benefits, separate from TopCoin balances)
                </p>
                <p className="text-dark opacity-50">
               {/*    Cash Wallets are company-funded loyalty rewards that may be
                  released as customers reach specific TopCoin milestones. These
                  rewards are not savings accounts, investment products, or
                  interest-bearing instruments. */}
                  Reward Cash Wallets display merchant-funded discount allocations that may be 
                  released when specific TopCoin milestones are reached.
                </p>
                <p className="text-dark opacity-50">
{/*                   TopCoin UK is a loyalty and rewards programme. It is not
                  regulated by the Financial Conduct Authority (FCA). TopCoin is
                  not a cryptocurrency, investment, or financial product. Cash
                  rewards are discretionary and subject to programme terms. */}
                </p>


                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      Reward Cash Wallets:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                        Are not bank accounts
                      </li>
                      <li>
                        Are not savings products
                      </li>
                      <li>
                        Are not investment or interest-bearing instruments
                      </li>
                      <li>
                        Do not represent customer deposits
                      </li>
                    </ul>
                  </div>
                </div>

                <p className="text-dark opacity-50">
                  Any reward amounts shown are discretionary loyalty benefits, 
                  subject to programme terms and availability.
                </p>
                <h5 className="fw-medium text-dark-emphasis fw-bold mt-2">
                  Important Information
                </h5>
                <p className="text-dark opacity-50">
                  TopCoin UK is a loyalty and advertising programme, not a financial service.
                </p>
                <p className="text-dark opacity-50">
                  TopCoin is not regulated by the Financial Conduct Authority (FCA) and is not a cryptocurrency, 
                  investment, or payment instrument.
                </p>

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      All rewards are:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                        Merchant-funded
                      </li>
                      <li>
                        Non-guaranteed
                      </li>
                      <li>
                        Issued at the discretion of the programme
                      </li>
                      <li>
                        Subject to applicable terms and conditions
                      </li>
                    </ul>
                  </div>
                </div>


                <h5 className="fw-medium text-dark-emphasis fw-bold mt-4">
                  Key Notice
                </h5>
                <p className="text-dark opacity-50">
                  TopCoin loyalty and Reward Cash Wallet figures are used solely to track participation 
                  and promotional rewards within the TopCoin UK system
                </p>
                <p className="text-dark opacity-50">
                  They do not represent financial returns, growth, or guaranteed value.
                </p>


                {/* section2 */}
                <h5 className="fw-medium text-dark-emphasis fw-bold mt-4">
                  How Reward Cash Wallets Unlock
                </h5>
                <p className="text-dark opacity-50">
                  As you participate in the TopCoin UK loyalty programme and collect TopCoins from participating businesses, 
                  Reward Cash Wallets may become available at certain milestone levels.
                </p>
                <p className="text-dark opacity-50">
                  Reward Cash Wallets are promotional loyalty features linked to merchant-funded discounts.
                </p>
                 <p className="text-dark opacity-50">
                  They are not savings accounts, investments, interest-bearing products, or financial instruments.
                </p>

                
                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                    {/*   These cash rewards are released automatically as you
                      progress through your TopCoin Wallets: */}
                      The milestones below indicate when a Reward Cash Wallet becomes viewable or eligible, 
                      subject to programme rules and availability:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>{/* Bronze Cash reward wallet 1 opens at 20,000 TopCoin */}
                        Bronze Reward Cash Wallet – available from 20,000 TopCoins
                      </li>
                      <li>
                        {/* Nickel cash reward wallet 2 opens at 200,000 TopCoin */} 
                        Nickel Reward Cash Wallet – available from 200,000 TopCoins 
                      </li>
                      <li>
                        {/* Titanium cash reward wallet 3 opens at 2,000,000 TopCoin */} 
                        Titanium Reward Cash Wallet – available from 2,000,000 TopCoins
                      </li>
                      <li>
                        {/* Silver cash reward wallet 4 opens at 4,000,000 TopCoin */}  
                        Silver Reward Cash Wallet – available from 4,000,000 TopCoins
                      </li>
                      <li>
                        {/* Palladium cash reward wallet 5 opens at 8,000,000 TopCoin */}   
                        Palladium Reward Cash Wallet – available from 8,000,000 TopCoins
                      </li>
                      <li>{/* 
                        Platinum cash reward wallet 6 opens at 12,000,000 TopCoin  */} 
                        Platinum Reward Cash Wallet – available from 12,000,000 TopCoins
                      </li>
                      <li>
                        {/* Iridium cash reward wallet 7 opens at 16,000,000 TopCoin */}  
                        Iridium Reward Cash Wallet – available from 16,000,000 TopCoins
                      </li>
                      <li>
                        {/* Gold cash reward wallet 8 opens at 20,000,000 TopCoin */}
                        Gold Reward Cash Wallet – available from 20,000,000 TopCoins
                      </li>
                      <li>
                        {/* Eternity cash reward wallet 9 opens at 30,000,000 TopCoin */}
                        Eternity Reward Cash Wallet – available from 30,000,000 TopCoins
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      Important Notice
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                        Reward Cash Wallets display promotional discount allocations only
                      </li>
                      <li>
                        Availability does not guarantee payout
                      </li>
                      <li>
                       Values shown are illustrative and subject to programme terms
                      </li>
                      <li>
                       TopCoin is not money, not a cryptocurrency, and not an investment
                      </li>
                      <li>
                        TopCoin UK is not regulated by the Financial Conduct Authority (FCA)
                      </li>
                    </ul>
                  </div>
                </div>


                {/* end */}
              </div>


              {/* coming soon */}
              <div className="mt-4">
                <h2 className=" text-theme">
                  {/* How Is Your Cash Share Calculated? */}
                  How Are Reward Cash Allocations Displayed?
                </h2>

                <p className="text-dark opacity-50">
                  TopCoin UK operates a loyalty and promotional rewards programme, 
                  funded by participating merchants.
                </p>
                <p className="text-dark opacity-50">
                  The information below explains how promotional discount allocations 
                  are displayed, not how investments or savings work.
                </p>
                {/* <ul className="text-dark-emphasis">
                  <li>Total TopCoin across all customers: 1,000,000</li>
                  <li>Your TopCoin at that level: 25,000</li>
                  <li>Cash in the wallet: £20,000</li>
                </ul> */}
                <h4 className="text-theme mt-3">
                  {/* How the Reward Is Shared? */}
                  How Promotional Reward Allocations Are Shown
                </h4>
                <div className="d-flex flex-column text-dark-emphasis gap-3 mb-4">
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 1 – Allocation Basis {/* Wallet Allocation Basis */}</h5>
                    <p className="mb-0">
                      {/* The total cash in the reward wallet is shared proportionally among eligible 
                      TopCoin holders at that wallet level. */}
                      Participating businesses may contribute promotional discount amounts to Reward Cash Wallet pools as part 
                      of marketing and advertising activity.
                    </p>
                    <p className="mb-0">
                      These amounts are not customer deposits and are not held as savings or investments.
                    </p>
                  </div>
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 2 – Proportional Display{/* Your Proportional Share */}</h5>
                    <p className="mb-0">
                     {/*  Your share is calculated based on your TopCoin balance relative to the 
                      total TopCoin at that level. */}
                      Your displayed allocation is calculated for illustrative and tracking purposes only, based on:
                    </p>

                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        The number of TopCoins you have collected
                      </li>
                      <li>
                        The total number of TopCoins recorded across eligible participants at that level
                      </li>
                    </ul>

                    <p className="mb-0">
                      This calculation is used solely to show how promotional discounts are proportionally 
                      associated with TopCoin participation.
                    </p>

                    
                  </div>
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 3 – Availability Status{/* Reward Release */}</h5>
                    <p className="mb-0">
                      {/* Once the wallet milestone is unlocked, your allocated cash reward becomes 
                      available to withdraw, subject to platform rules and verification. */}
                      When a Reward Cash Wallet milestone becomes available, the system may display an 
                      allocated promotional discount amount, subject to:
                    </p>
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        Programme rules
                      </li>
                      <li>
                        Merchant participation
                      </li>
                      <li>
                        Verification and eligibility checks
                      </li>
                    </ul>

                    <p className="mb-0">
                      Availability does not guarantee payment and may change based on programme terms.
                    </p>
                  </div>


                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      Important Information
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                       Reward Cash Wallets do not represent bank accounts, investments, or financial products
                      </li>
                      <li>
                        Displayed values are illustrative promotional allocations, not guaranteed payouts
                      </li>
                      <li>
                       TopCoins do not earn interest and do not increase in value
                      </li>
                      <li>
                       TopCoin UK does not accept customer deposits or hold client funds
                      </li>
                      <li>
                        TopCoin UK is not regulated by the Financial Conduct Authority (FCA)
                      </li>
                    </ul>
                  </div>
                </div>
                {/* end */}



                
                </div>
                {/* <h4 className="mt-3 text-theme">
                  What Is My TopCoin UK Worth?
                </h4> */}
                <div className="d-flex flex-column mt-3 gap-3">
                  {/* <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">
                      To calculate your total value:
                    </h5>
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        1. Add up the cash from every TopCoin UK Cash Wallet
                        you’ve unlocked
                      </li>
                      <li>
                        2. Add that to the TopCoin UK in your TopCoin Wallets
                      </li>
                    </ul>
                  </div> */}
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3 mt-4 mb-4">
                    <h5 className="text-dark-emphasis">
                      Important Clarifications:
                    </h5>
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        {/* TopCoin UK is not an investment product */}
                        TopCoin UK is a loyalty and advertising rewards platform
                      </li>
                      <li>
                        {/* TopCoin does not represent ownership, equity, or profit rights */}
                        TopCoin is not an investment product
                      </li>
                      <li>
                        {/* Cash rewards are not interest, yield, or financial returns */}
                        TopCoin does not represent ownership, equity, shares, or profit rights
                      </li>
                      <li>
                        {/* Examples shown are illustrative only */}
                        Any cash amounts shown relate to merchant-funded promotional discounts
                      </li>
                      <li>
                        {/* Rewards depend on platform activity and wallet unlock conditions */}
                        Cash rewards are not interest, yield, or financial returns
                      </li>
                      <li>
                        Examples and figures displayed are illustrative only
                      </li>
                      <li>
                        Rewards depend on programme activity, merchant participation, and wallet availability rules
                      </li>
                    </ul>
                  </div>
                  {/* <div className="text-center text-dark-emphasis">
                    <p>
                      The total shows the real value of your journey with
                      TopCoin.
                    </p>
                  </div> */}
                </div>
              </div>
              <h4 className="text-theme mt-3">
                  {/* How to View Your Total Rewards? */}
                  How to View Your Rewards
                </h4>
                <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3 mt-3 mb-4">
                    <h5 className="text-dark-emphasis">
                      {/* To see your total rewards: */}
                      To view your rewards within the platform:
                    </h5>
                    <ol className="mb-0 text-dark-emphasis">
                      <li>
                        {/* View the cash rewards released from unlocked cash wallets */}
                        View any available promotional discounts shown in unlocked Reward Cash Wallets
                      </li>
                      <li>
                        {/* View your TopCoin balance separately in your TopCoin wallets */}
                        View your TopCoin balance separately within your TopCoin Wallet
                      </li>
                    </ol>

                    <p className="text-dark opacity-50 mt-1">
                      TopCoin balances and Reward Cash Wallet amounts are displayed independently and 
                      serve different tracking purposes within the loyalty programme.
                    </p>
                  </div>

                   <h4 className="text-theme mt-3">
                    Important Notice
                  </h4>
                  <p className="text-dark opacity-50">
                    All rewards shown are loyalty rewards, not financial assets.
                  </p>
                  <p className="text-dark opacity-50">
                    They do not constitute savings, investments, or payment accounts.
                  </p>


                  {/* new section */}
                <div className="card bg-white border border-opacity-75 shadow-sm mt-3 mb-2">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      TopCoin UK does not:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>
                       Provide financial advice
                      </li>
                      <li>
                        Accept customer deposits
                      </li>
                      <li>
                       Offer regulated financial services
                      </li>
                    </ul>
                    {/*   <p className="text-dark opacity-50 m-1">
                          TopCoin UK is not regulated by the Financial Conduct Authority (FCA), as it does not operate as a 
                          financial institution or investment provider.
                      </p> */}
                  </div>
                </div>

               


               
                  <div className="text-center text-dark-emphasis ">
                    <strong>
                   {/*  <p>
                      These are loyalty rewards, not financial assets.
                    </p> */}

                    <p className="m-4">
                    {/*   TopCoin UK is a loyalty and rewards platform. It is not regulated by the Financial Conduct Authority (FCA), 
                      as it does not provide financial services, investments, or payment products. */}
                      TopCoin UK is not regulated by the Financial Conduct Authority (FCA), 
                      as it does not operate as a financial institution or investment provider.
                    </p>
                    </strong>
                  </div>


                    {/* new changing content */}
              <div className="p-3 border text-center shadow-sm bg-primary rounded-5">
                <h5 className="mb-0 text-white">
                  {/* Loyalty. Progress. Real Cash Rewards. */}
                  Loyalty Progress & Promotional Rewards
                </h5>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <div className="bg-primary rounded-4 mt-4 p-4">
              <div className="">
                <h1 className="text-white">
                  Welcome to TopCoin UK - Where Loyalty Turns into Real Rewards!
                </h1>
                <p className="text-white opacity-50">
                  Once someone joins TopCoin UK, they’re given their own
                  Personal ID and Referring customer’s numbers — instantly unlocking access to our
                  powerful earning system.
                </p>

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      How Agents Earn Free TopCoin UK:
                    </h5>
                    <p className="text-dark-emphasis mb-1">
                      As a TopCoin UK Agent, you earn free units effortlessly
                      every time you refer someone!
                    </p>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li> When someone you introduce makes a purchase,</li>
                      <li>And they enter yourReferring customer’s numbers,</li>
                      <li>
                        You’ll instantly receive the same number of TopCoin they
                        earn — automatically!
                      </li>
                    </ul>
                    <p className="mb-1 text-dark-emphasis">
                      The person must be a registered TopCoin UK member.
                    </p>
                    <p className="mb-0 text-dark-emphasis">
                      They must enter your Referring customer’s numbers at checkout.
                    </p>
                  </div>
                </div>
                <div className=" py-4">
                  <p className="mb-1 text-white opacity-50">
                    The more people you refer, the more your TopCoin balance grows
                    — and with it, your TopCoin UK wallet power. Start sharing.
                    Start earning. Be the reason others discover TopCoin UK —
                    and get rewarded every step of the way.
                  </p>
                  <p className="text-white opacity-50 mb-0">
                    Your loyalty is your power. Make it count.
                  </p>
                </div>
              </div>
            </div> */}
          {/* <div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 1</h5>
                  <p className="mb-0">from 1 to 19,999 units</p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 2</h5>
                  <p className="mb-0">
                    from 20,000 to 199,999 units at the start this wallet is
                    worth worth £100
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 3</h5>
                  <p className="mb-0">
                    from 200,000 to 1,999,999 unit at the start this wallet is
                    worth £1000
                  </p>
                </div>
              </div>

              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 4</h5>
                  <p className="mb-0">
                    from 2,000,000 to 9,999,999 at the start this wallet is
                    worth £10,000
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 5</h5>
                  <p className="mb-0">
                    from 10,000,000 to 19,999,999 at the start this wallet it’s
                    worth £50,000
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 6</h5>
                  <p className="mb-0">
                    20,000,000 Plus hit this wallet and you have earned £100,000
                    Plus
                  </p>
                </div>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
};

export default RewardContent;
